import { useQuery } from "@tanstack/react-query";
import type { ScriptSpecs } from "./useStoryboardWithSlides";

export const useScriptSpecs = (path?: string) => {
  const query = useQuery({
    queryKey: ["scriptSpecs", path] as const,
    queryFn: async (): Promise<ScriptSpecs> => {
      const response = await fetch(path);
      if (!response.ok) {
        throw new Error(`Failed to fetch script specs: ${response.status}`);
      }
      return response.json();
    },
    enabled: !!path,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    data: query.data,
    thinkingProcess: query.data?.thinking_process ?? [],
    scriptSections: query.data?.sections ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    isSuccess: query.isSuccess,
    error: query.error,
    refetch: query.refetch,
  };
};
